import React from "react";
import { NavLink } from "react-router-dom";
import funelyMark from "assets/images/funely-mark.svg";

interface MobileNavBarBrandProps {
  handleClick: () => void;
}

export const MobileNavBarBrand: React.FC<MobileNavBarBrandProps> = ({
  handleClick,
}) => {
  return (
    <div onClick={handleClick} className="mobile-nav-bar__brand">
      <NavLink to="/">
        <img
          className="mobile-nav-bar__logo"
          src={funelyMark}
          alt="Funely"
          width="82"
          height="24"
        />
      </NavLink>
    </div>
  );
};
